import { useState } from 'react';
import { Menu, X, Bot } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import {
  Avatar,
  Button,
} from '@randompedestrian07/ui';
import { Link } from 'react-router-dom';

export const Header = () => {
  const { user } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  // This is a minimal mobile header that matches Aria's aesthetic
  return (
    <header className="h-16 border-b border-stroke bg-panel/80 backdrop-blur-lg px-4 flex items-center justify-between md:hidden sticky top-0 z-50">
      <div className="flex items-center gap-3">
        <Button variant="ghost" size="icon" className="text-muted">
          <Menu size={20} />
        </Button>
        <Link to="/" className="flex items-center gap-2">
          <Bot size={20} className="text-accent" />
          <span className="font-bold text-text tracking-tight">Outer Haven Bots</span>
        </Link>
      </div>

      <div className="flex items-center gap-3">
        <Avatar
          imageUrl={user?.avatarUrl || null}
          initials={user?.username?.slice(0, 2).toUpperCase() || '?'}
          size="sm"
        />
      </div>
    </header>
  );
};
